export function assert(
  condition: unknown,
  message?: string
): asserts condition {
  if (!condition) throw new Error(message);
}

export function intentionallyIgnoreError(error: unknown) {
  console.warn(error);
  return undefined;
}
